<template>

	<div class="box" v-if="content">

		<template v-if="content.length > 0">
			<h2>{{content[0].group ? content[0].group : 'Quick links'}}</h2>
		</template>
		<template v-else>
			<h2>Quick links</h2>
			<p>You don't have any {{mainslug}} yet :/</p>
		</template>

		<div class="negative-padding">

			<table class="data">
				<tr v-for="object in content" v-bind:key="object.entity.id">
					<td></td>
					<td>
						<router-link :to="`/${mainslug}/${object.entity.id}`"><strong>{{object.entity.translations[Object.keys(object.entity.translations)[0]].value}}</strong>
						</router-link>
					</td>
					<td class="align-right">{{object.instances}}</td>
					<td>
						<router-link v-if="user.roles['Admin']" class="btn-edit btn-show-on-hover" :to="`/${mainslug}/edit/${object.entity.id}`">
							<i class="fa fa-pen"></i></router-link>
					</td>
				</tr>
			</table>

		</div>

		<div v-if="user.roles['Admin']">
			<br>
			<router-link class="btn btn-add-object" :to="`/${mainslug}/add/object`">Add object</router-link>
		</div>
	</div>

</template>

<script>

export default {
	name: 'quicklinks',
	props: {
		content: Array
	},
	data () {
		return {
			mainslug: this.getMainSlug(),
			user: this.$store.state.user
		}
	},

	methods: {
		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
